import Reveal from '@/components/base/Reveal';
import { caseStudies } from '@/mocks/home';

export default function CaseStudies() {
  return (
    <section id="results" className="relative py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Client Results
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            Real Businesses. Measurable Outcomes.
          </h2>
          <p className="mt-4 text-foreground-600">
            A look at what happens when marketing stops being a guessing game and becomes a system.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {caseStudies.map((c, i) => (
            <Reveal key={c.tag} delay={i * 80}>
              <div className="flex h-full flex-col rounded-2xl border border-white/8 bg-background-100 p-7">
                <div className="flex items-center justify-between">
                  <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
                    {c.tag}
                  </span>
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-primary-400">
                    <i className="ri-arrow-right-up-line"></i>
                  </span>
                </div>

                <p className="mt-5 font-heading font-extrabold text-2xl text-primary-400">
                  {c.result}
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{c.context}</p>

                <div className="mt-4 rounded-lg bg-background-200/50 border border-white/5 p-4">
                  <p className="text-xs font-label font-semibold uppercase tracking-wide text-foreground-600">
                    Outcome
                  </p>
                  <p className="mt-1 text-sm text-foreground-950">{c.outcome}</p>
                </div>

                <blockquote className="mt-5 pt-5 border-t border-white/5">
                  <p className="text-sm text-foreground-700 italic leading-relaxed">
                    &ldquo;{c.quote}&rdquo;
                  </p>
                  <footer className="mt-3 text-xs text-foreground-600 font-label font-medium">
                    — {c.author}
                  </footer>
                </blockquote>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}